// @flow
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Modal from '@localytics/loc-components/lib/Modal';
import withLeaveDialog from './withLeaveDialog';
import { StandardNode } from './StandardNode';
import { displayStringFromMinutes } from '../util/TimeUtils';
import DelayNodeModal from './DelayNodeModal';
import { deselectNode } from '../actions/tree';
import { modifyNode } from '../actions/api';
import { DELAY_ICON, DELAY_FILL_COLOR } from '../constants/Style';
import { getQueryParams } from '../util/RouterUtils';
import './stylesheets/NodeModal.scss';

type DelayNodeProps = {
  duration_minutes: number,
  unit: string,
  height: number,
  rx: number,
  ry: number,
  selected: boolean,
  dispatch: Function,
  appsInVersion: Array<{
    app_uuid: string,
    olap_id: number
  }>,
  nodesInVersion: Object,
  currentVersionId: number,
  currentOrchestrationId: number,
  currentOrgId: number,
  appGroupId: number,
  name: string,
  parentName: string,
  editable: boolean
};

export const DelayNodeTitle = (props: {
  durationMinutes: number,
  unit: string
}) => (
  <g>
    <text
      fill="#555555"
      style={{
        fontSize: '16px'
      }}
    >
      {displayStringFromMinutes(props.durationMinutes, props.unit)}
    </text>
    <text
      y="20"
      fill="#818799"
      style={{
        fontSize: '14px'
      }}
    >
      Wait Timer {/* todo: this should reference the previous node */}
    </text>
  </g>
);

class DelayNode extends React.Component<DelayNodeProps> {
  submitForm: Function = ({ duration_minutes, unit, node_type }) => {
    if (!this.props.editable) {
      return;
    }
    const {
      currentVersionId: versionId,
      currentOrchestrationId: orchestrationId,
      currentOrgId: orgId,
      appGroupId,
      appsInVersion,
      nodesInVersion,
      name: nodeName
    } = this.props;
    this.props.dispatch(
      modifyNode({
        apps: appsInVersion,
        nodes: nodesInVersion,
        versionId,
        orchestrationId,
        orgId,
        appGroupId,
        nodeName,
        newNodeData: {
          duration_minutes,
          unit,
          node_type
        }
      })
    );
    this.props.dispatch(deselectNode());
  };
  cancelForm: Function = () => this.props.dispatch(deselectNode());
  closeForm: Function = () => this.props.dispatch(deselectNode());
  render() {
    const {
      currentVersionId: versionId,
      currentOrchestrationId: orchestrationId,
      currentOrgId: orgId,
      duration_minutes: durationMinutes,
      unit,
      selected,
      height,
      rx,
      ry,
      parentName,
      editable
    } = this.props;

    const ModalWithLeaveDialog = editable ? withLeaveDialog(Modal) : Modal;
    return (
      <StandardNode
        height={height}
        rx={rx}
        ry={ry}
        icon={DELAY_ICON}
        iconFill={DELAY_FILL_COLOR}
      >
        <ModalWithLeaveDialog show={selected} onHide={() => {}}>
          <DelayNodeModal
            currentOrgId={orgId}
            currentVersionId={versionId}
            currentOrchestrationId={orchestrationId}
            duration_minutes={durationMinutes}
            unit={unit}
            height={height}
            rx={rx}
            ry={ry}
            submitFormCallback={this.submitForm}
            cancelCallback={this.cancelForm}
            closeCallback={this.closeForm}
            parentName={parentName}
            editable={editable}
          />
        </ModalWithLeaveDialog>
        <DelayNodeTitle durationMinutes={durationMinutes} unit={unit} />
      </StandardNode>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    orgId: currentOrgId,
    orchestrationId: currentOrchestrationId,
    versionId: currentVersionId
  } = getQueryParams(ownProps.location);
  const { api: { versionsByOrchestrationId } } = state;
  const version =
    versionsByOrchestrationId[currentOrchestrationId][currentVersionId] || {};
  const {
    apps: appsInVersion,
    nodes: nodesInVersion,
    app_group_id: appGroupId
  } = version;
  return {
    appsInVersion,
    nodesInVersion,
    appGroupId,
    currentOrgId,
    currentVersionId,
    currentOrchestrationId
  };
};

const ConnectedDelayNode = withRouter(connect(mapStateToProps)(DelayNode));

export { ConnectedDelayNode as DelayNode };



// WEBPACK FOOTER //
// ./src/components/DelayNode.jsx